import Header from "../Components/Header";
import SmallHero from "../Components/SmallHero";
import Footer from "../Components/Footer";
import MatchFilter from "./MatchFilter";

export default function Matchmaking () {

    document.body.classList.add('live');

    return (
        <div className="base-box fixed scroll-box" id="page-top">
        <Header />
        <div className="base-item" >
            <SmallHero />
        </div>
        <main className="main-content">
            <MatchFilter type="matchmaking" />
        </main>
        <Footer />
        </div>
    );
}
